module.exports = __webpack_public_path__ + "img/cbhb.42798542.jpg";